import AccessComponent, * as fromAccessComponent from './AccessComponentReducer.js';
import ACCPSupervisor, * as fromACCPSupervisor from './ACCPSupervisorReducer.js'
import ACCPBoss, * as fromACCPBoss from './ACCPBossReducer.js'
import AdministrativeRepresentative, * as fromAdministrativeRepresentative from './AdministrativeRepresentativeReducer.js'
import Attachment, * as fromAttachment from './AttachmentReducer.js';
import Auth, * as fromAuthenticate from './LoginReducer.js';
import Blob, * as fromBlob from './BlobReducer.js';
import Bookmark, * as fromBookmark from './BookmarkReducer.js'
import Category, * as fromCategory from './CategoryReducer.js'
import CategoryAvailable, * as fromCategoryAvailable from './CategoryAvailableReducer.js'
import CategoryCourseAvailable, * as fromCategoryCourseAvailable from './CategoryCourseAvailableReducer.js'
import CategoryCourse, * as fromCategoryCourse from './CategoryCourseReducer.js'
import ClientProcedure, * as fromClientProcedure from './ClientProcedureReducer.js'
import Communication, * as fromEmployeeCommunicationProgram from './CommunicationReducer.js';
import CommunicationProgram, * as fromCommunicationProgram from './CommunicationProgramReducer.js';
import CommunicationProgramKeyUser, * as fromCommunicationProgramKeyUser from './CommunicationProgramKeyUserReducer.js';
import CommunicationStatus, * as fromCommunicationStatus from './CommunicationStatusReducer.js';
import CommunicationQuiz, * as fromEmployeeCommunicationQuiz from './CommunicationQuizReducer.js';
import Company, * as fromCompany from './CompanyReducer.js'
import Contract, * as fromContract from './ContractReducer.js';
import Course, * as fromCourse from './CourseReducer.js';
import Courses, * as fromCourses from './CoursesReducer.js';
import CourseAvailable, * as fromCourseAvailable from './CourseAvailableReducer.js';
import CourseMultimedia, * as fromCourseMultimedia from './CourseMultimediaReducer.js';
import Diffusion, * as fromDiffusion from './DiffusionReducer.js'
import Disclaimer, * as fromDisclaimer from './DisclaimerReducer.js'
import Front, * as fromFront from './FrontReducer.js';
import HomologousProcedure, * as fromHomologousProcedure from './HomologousProcedureReducer.js'
import PEPRepresentative, * as fromPEPRepresentative from './PEPRepresentativeReducer.js'
import TechnicalRepresentative, * as fromTechnicalRepresentative from './TechnicalRepresentativeReducer.js'
import Sas, * as fromSasToken from './SasReducer.js';
import Specialty, * as fromSpecialty from './SpecialtyReducer.js'
import SSPARepresentative, * as fromSSPARepresentative from './SSPARepresentativeReducer.js'
import Subdirections, * as fromSubDirections from './SubdirectionsReducer.js';
import TableData, * as fromTableData from './DataTableReducer.js';
import Test, * as fromTest from './TestReducer.js'
import Work, * as fromWork from './WorkReducer.js';
import WorkCycle, * as fromWorkCycle from './WorkCycleReducer';
import ClientReport, * as fromClientReport from './ClientReportReducer';
import Process, * as fromProcess from './ProcessReducer';
import ManagementReport, * as fromManagementReport from './ManagementReportReducer';
import OnSiteEvaluations, * as fromOnSiteEvaluations from './OnSiteEvaluationsReducer.js'
import { CLEAR_ALL_STATES } from '../actions/LoginActions';
import { TrainingReducer } from './TrainingReducer';
import { SystemReducer } from './SystemReducer';
import { SignatureReducer } from './SignatureReducer.js';

import { UserSearchReducer } from './UserSearchReducer';
import { HistoryCampaignReducer } from "./HistoryCampaignReducer";
import { DailyComplianceReducer } from './DailyComplianceReducer';
import { ComplianceMatrixbyPositionReducer } from './ComplianceMatrixbyPositionReducer'
import { ReportCommunicationProgramAction } from "./ReportCommunicationProgramReducer"
import { CotplayHubReducer } from "./CotplayHubReducer";
import { ListadoKeyUserReducer } from './ListadoKeyUserReducer.js'
import { KUCatalogueReducer} from './KUCatalogueReducer.js'

import { combineReducers } from 'redux';

const appReducer = combineReducers({
    TableData,
    ACCPSupervisor,
    ACCPBoss,
    Auth,
    AdministrativeRepresentative,
    Sas,
    Blob,
    AccessComponent,
    CourseMultimedia,
    Courses,
    Test,
    Subdirections,
    Contract,
    Work,
    WorkCycle,
    Attachment,
    ClientProcedure,
    CommunicationProgram,
    CommunicationProgramKeyUser,
    Course,
    CourseAvailable,
    CategoryAvailable,
    Category,
    CategoryCourse,
    CategoryCourseAvailable,
    Company,
    Diffusion,
    Disclaimer,
    HomologousProcedure,
    Specialty,
    SSPARepresentative,
    Communication,
    CommunicationQuiz,
    Front,
    CommunicationStatus,
    Bookmark,
    TechnicalRepresentative,
    PEPRepresentative,
    ClientReport,
    Process,
    ManagementReport,
    TrainingReducer,
    SystemReducer,
    UserSearchReducer,
    HistoryCampaignReducer,
    DailyComplianceReducer,
    ComplianceMatrixbyPositionReducer,
    ReportCommunicationProgramAction,
    CotplayHubReducer,
    OnSiteEvaluations,
    SignatureReducer,
    ListadoKeyUserReducer,
    KUCatalogueReducer
});

const rootReducer = (state, action) => {
    // Clear all data in redux store to initial.
    if (action.type === CLEAR_ALL_STATES)
        state = undefined;

    return appReducer(state, action);
};

export default rootReducer;

//Subdirections 
export const getSubirs = state =>
    fromSubDirections.getSubirs(state.Subdirections);

//Fronts
export const getFront = state =>
    fromFront.getFront(state.Front);

//ClientReport
export const getClientReport = state =>
    fromClientReport.getClientReport(state.ClientReport);

//Work
export const getWork = state =>
    fromWork.getWork(state.Work);

//Specialty
export const getSpecialty = state =>
    fromSpecialty.getSpecialty(state.Specialty);

export const getIsLoadingSpecialty = state =>
    fromSpecialty.getIsLoadingSpecialty(state.Diffusion);

export const getSpecialtyFilter = state =>
    fromSpecialty.getSpecialtyFilter(state.Specialty);

//Contracts
export const getContract = state =>
    fromContract.getContract(state.Contract);

//Diffusion
export const getDiffusion = state =>
    fromDiffusion.getDiffusion(state.Diffusion);
export const getIsLoadingDiffusion = state =>
    fromDiffusion.getIsLoadingDiffusion(state.Diffusion);

//Bookmark
export const getBookmark = state =>
    fromBookmark.getBookmark(state.Bookmark);
export const getIsLoadingBookmark = state =>
    fromBookmark.getIsLoadingBookmark(state.Bookmark);
//Bookmark Preview
export const getBookmarkPreview = state =>
    fromBookmark.getBookmarkPreview(state.Bookmark);
export const getIsLoadingBookmarkPreview = state =>
    fromBookmark.getIsLoadingBookmarkPreview(state.Bookmark);
//BookmarkFilters
export const getBookmarkFilters = state =>
    fromBookmark.getBookmarkFilters(state.Bookmark);
export const getIsLoadingBookmarkFilters = state =>
    fromBookmark.getIsLoadingBookmarkFilters(state.Bookmark);
export const getBookmarkCourseFilters = state =>
    fromBookmark.getBookmarkCourseFilters(state.Bookmark);
//BookmarkSupervisor
export const getEmployeeSupervisor = state =>
    fromBookmark.getEmployeeSupervisor(state.Bookmark);
export const getIsLoadingEmployeeSupervisor = state =>
    fromBookmark.getIsLoadingEmployeeSupervisor(state.Bookmark);
//Auth

export const authIsLoading = state =>
    fromAuthenticate.authIsLoading(state.Auth);
export const authError = state =>
    fromAuthenticate.authError(state.Auth);
export const auth = state =>
    fromAuthenticate.auth(state.Auth);

export const IDMScreenIsLoading = state =>
    fromAuthenticate.IDMScreenIsLoading(state.Auth);
export const IDMScreenError = state =>
    fromAuthenticate.IDMScreenError(state.Auth);
export const IDMScreen = state =>
    fromAuthenticate.IDMScreen(state.Auth);

export const erapidsTokenIsLoading = state =>
    fromAuthenticate.erapidsTokenIsLoading(state.Auth);
export const erapidsTokenError = state =>
    fromAuthenticate.erapidsTokenError(state.Auth);
export const erapidsToken = state =>
    fromAuthenticate.erapidsToken(state.Auth);

export const erapidsRefreshTokenIsLoading = state =>
    fromAuthenticate.erapidsRefreshTokenIsLoading(state.Auth);
export const erapidsRefreshTokenError = state =>
    fromAuthenticate.erapidsRefreshTokenError(state.Auth);
export const erapidsRefreshToken = state =>
    fromAuthenticate.erapidsRefreshToken(state.Auth);

export const employeeByIdIsLoading = state =>
    fromAuthenticate.employeeByIdIsLoading(state.Auth);
export const employeeById = state =>
    fromAuthenticate.employeeById(state.Auth);
export const acceptDisclaimer = state =>
    fromAuthenticate.acceptDisclaimer(state.Auth);

export const acceptDisclaimerIsLoading = state =>
    fromAuthenticate.acceptDisclaimerIsLoading(state.Auth);



//Courses
export const coursesIsLoading = state =>
    fromCourses.coursesIsLoading(state.Courses);
export const coursesError = state =>
    fromCourses.coursesError(state.Courses);
export const courses = state =>
    fromCourses.courses(state.Courses);
export const getCoursesById = (state, courseId) =>
    fromCourses.getCoursesById(state.Courses, courseId)
//CourseCategoryAvailable
export const getCourseCategoryAvailable = state =>
    fromCourse.getCourseCategoryAvailable(state.Course);
export const getIsLoadingCourseCategoryAvailable = state =>
    fromCourse.getIsLoadingCourseCategoryAvailable(state.Course);
//CourseCategory
export const getCourseCategory = state =>
    fromCourse.getCourseCategory(state.Course);
export const getIsLoadingCourseCategory = state =>
    fromCourse.getIsLoadingCourseCategory(state.Course);
//CourseClientProcedure
export const getCourseClientProcedureAvailable = state =>
    fromCourse.getCourseClientProcedureAvailable(state.Course);
export const getIsLoadingCourseClientProcedureAvailable = state =>
    fromCourse.getIsLoadingCourseClientProcedureAvailable(state.Course);
//CourseHomologousProcedure
export const getCourseClientProcedure = state =>
    fromCourse.getCourseClientProcedure(state.Course);
export const getIsLoadingCourseClientProcedure = state =>
    fromCourse.getIsLoadingCourseClientProcedure(state.Course);

export const getCourseHomologousProcedureAvailable = state =>
    fromCourse.getCourseHomologousProcedureAvailable(state.Course);
export const getIsLoadingCourseHomologousProcedureAvailable = state =>
    fromCourse.getIsLoadingCourseHomologousProcedureAvailable(state.Course);
//CourseHomologousProcedure
export const getCourseHomologousProcedure = state =>
    fromCourse.getCourseHomologousProcedure(state.Course);
export const getIsLoadingHomologousProcedureCourse = state =>
    fromCourse.getIsLoadingCourseHomologousProcedure(state.Course);
//CoursesTestAvailable
export const getCourseTestAvailable = state =>
    fromCourse.getCourseTestAvailable(state.Course);
export const getIsLoadingCourseTestAvailable = state =>
    fromCourse.getIsLoadingCourseTestAvailable(state.Course);
//CoursesTest
export const getCourseTest = state =>
    fromCourse.getCourseTest(state.Course);
//CoursesWorkCycleAvailable
export const getCourseWorkCycleAvailable = state =>
    fromCourse.getCourseWorkCycleAvailable(state.Course);
export const getIsLoadingCourseWorkCycleAvailable = state =>
    fromCourse.getIsLoadingCourseWorkCycleAvailable(state.Course);
//CoursesWorkCycle
export const getCourseWorkCycle = state =>
    fromCourse.getCourseWorkCycle(state.Course);

//AttachmentAvailable
export const attachmentIsLoading = state =>
    fromAttachment.attachmentIsLoading(state.Attachment);
export const attachmentError = state =>
    fromAttachment.attachmentError(state.Attachment);
export const getAttachment = state =>
    fromAttachment.attachment(state.Attachment);

//DataTable
export const getIsLoadingTableData = state =>
    fromTableData.getIsLoadingTableData(state.TableData);
export const getErrorTableData = state =>
    fromTableData.getErrorTableData(state.TableData);
export const getTableData = state =>
    fromTableData.getTableData(state.TableData);

//SasToken
export const sasIsLoading = state =>
    fromSasToken.sasIsLoading(state.Sas);
export const sasError = state =>
    fromSasToken.sasError(state.Sas);
export const sas = state =>
    fromSasToken.sas(state.Sas);

//blob 
export const blobIsLoading = state =>
    fromBlob.blobIsLoading(state.Blob);
export const blobError = state =>
    fromBlob.blobError(state.Blob);
export const blob = state =>
    fromBlob.blob(state.Blob);

//AccesCompnent 
export const accessComponentIsLoading = state =>
    fromAccessComponent.accessComponentIsLoading(state.AccessComponent);
export const accessComponentError = state =>
    fromAccessComponent.accessComponentError(state.AccessComponent);
export const accessComponent = state =>
    fromAccessComponent.accessComponent(state.AccessComponent);

//CourseMultimedia 
export const courseMultimediaIsLoading = state =>
    fromCourseMultimedia.courseMultimediaIsLoading(state.CourseMultimedia);
export const courseMultimediaError = state =>
    fromCourseMultimedia.courseMultimediaError(state.CourseMultimedia);
export const getCourseMultimedia = state =>
    fromCourseMultimedia.courseMultimedia(state.CourseMultimedia);

//Test
export const getTest = state =>
    fromTest.getTest(state.Test);
export const getIsLoadingTest = state =>
    fromTest.getIsLoadingTest(state.Test);
//TestFilters
export const getTestFilter = state =>
    fromTest.getTestFilter(state.Test);
export const getIsLoadingTestFilter = state =>
    fromTest.getIsLoadingTestFilter(state.Test);
//ExportTest
export const getExport = state =>
    fromTest.getExport(state.Test);
export const getIsLoadingExport = state =>
    fromTest.getIsLoadingExport(state.Test);
//Test Question
export const getTestQuestion = state =>
    fromTest.getTestQuestion(state.Test);
export const getIsLoadingTestQuestion = state =>
    fromTest.getIsLoadingTestQuestion(state.Test);

//WorkCycle
export const getWorkCycle = state =>
    fromWorkCycle.getWorkCycle(state.WorkCycle);
export const getIsLoadingWorkCycle = state =>
    fromWorkCycle.getIsLoadingWorkCycle(state.WorkCycle);
//WorkCycleFilters
export const getWorkCycleFilter = state =>
    fromWorkCycle.getWorkCycleFilter(state.WorkCycle);
export const getIsLoadingWorkCycleFilter = state =>
    fromWorkCycle.getIsLoadingWorkCycleFilter(state.WorkCycle);
//WorkCycleFilters
export const getWorkCycleEvaluation = state =>
    fromWorkCycle.getWorkCycleEvaluation(state.WorkCycle);
export const getIsLoadingWorkCycleEvaluation = state =>
    fromWorkCycle.getIsLoadingWorkCycleEvaluation(state.WorkCycle);
export const getListSubdirectionEvaluationData = state =>
    fromWorkCycle.getListSubdirectionEvaluationData(state.WorkCycle);
export const getListContractEvaluationData = state =>
    fromWorkCycle.getListContractEvaluationData(state.WorkCycle);
export const getListWorkEvaluationData = state =>
    fromWorkCycle.getListWorkEvaluationData(state.WorkCycle);
export const getListFrontEvaluationData = state =>
    fromWorkCycle.getListFrontEvaluationData(state.WorkCycle);
export const getListEmployeeEvaluationData = state =>
    fromWorkCycle.getListEmployeeEvaluationData(state.WorkCycle);
export const getListTestEvaluationData = state =>
    fromWorkCycle.getListTestEvaluationData(state.WorkCycle);
export const getListCommunicationProgramData = state =>
    fromWorkCycle.getListCommunicationProgramData(state.WorkCycle);

//CommunicationStatus
export const getCommunicationStatus = state =>
    fromCommunicationStatus.getCommunicationStatus(state.CommunicationStatus);
export const getIsLoadingCommunicationStatus = state =>
    fromCommunicationStatus.getIsLoadingCommunicationStatus(state.CommunicationStatus);

//CommunicationPrograms
export const getCommunicationProgram = state =>
    fromCommunicationProgram.getCommunicationProgram(state.CommunicationProgram);
export const getIsLoadingCommunicationProgram = state =>
    fromCommunicationProgram.getIsLoadingCommunicationProgram(state.CommunicationProgram);
//CommunicationProgramsFilters
export const getCommunicationProgramFilter = state =>
    fromCommunicationProgram.getCommunicationProgramFilter(state.CommunicationProgram);
export const getIsLoadingCommunicationProgramFilter = state =>
    fromCommunicationProgram.getIsLoadingCommunicationProgramFilter(state.CommunicationProgram);
//CommunicationDispatchFilters
export const getCommunicationDispatchFilter = state =>
    fromCommunicationProgram.getCommunicationDispatchFilter(state.CommunicationProgram)
export const getIsLoadingCommunicationDispatchFilter = state =>
    fromCommunicationProgram.getIsLoadingCommunicationDispatchFilter(state.CommunicationProgram);
//CommunicationProgramSummary
export const getCommunicationsProgramSummary = state =>
    fromCommunicationProgram.getCommunicationsProgramSummary(state.CommunicationProgram)
export const getIsLoadingCommunicationsProgramSummary = state =>
    fromCommunicationProgram.getIsLoadingCommunicationsProgramSummary(state.CommunicationProgram);
//CommunicationProgramSummaryFilters
export const getCommunicationsProgramSummaryFilters = state =>
    fromCommunicationProgram.getCommunicationsProgramSummaryFilters(state.CommunicationProgram)
export const getIsLoadingCommunicationsProgramSummaryFilters = state =>
    fromCommunicationProgram.getIsLoadingCommunicationsProgramSummaryFilters(state.CommunicationProgram);
//CommunicationProgramGraphics
export const getCommunicationGraphics = state =>
    fromCommunicationProgram.getCommunicationGraphics(state.CommunicationProgram);
export const communicationGraphicsIsLoading = state =>
    fromCommunicationProgram.communicationGraphicsIsLoading(state.CommunicationProgram);
//CommunicationProgramDetails
export const getCommunicationsProgramDetails = state =>
    fromCommunicationProgram.getCommunicationsProgramDetails(state.CommunicationProgram)
export const getIsLoadingCommunicationsProgramDetails = state =>
    fromCommunicationProgram.getIsLoadingCommunicationsProgramDetails(state.CommunicationProgram);

//CommunicationProgramKeyUsers
export const getCommunicationProgramKeyUser = state =>
    fromCommunicationProgramKeyUser.getCommunicationProgramKeyUser(state.CommunicationProgramKeyUser);
export const getIsLoadingCommunicationProgramKeyUser = state =>
    fromCommunicationProgramKeyUser.getIsLoadingCommunicationProgramKeyUser(state.CommunicationProgramKeyUser);
//CommunicationProgramsKeyUserFilters
export const getCommunicationProgramKeyUserFilter = state =>
    fromCommunicationProgramKeyUser.getCommunicationProgramKeyUserFilter(state.CommunicationProgramKeyUser);
export const getIsLoadingCommunicationProgramKeyUserFilter = state =>
    fromCommunicationProgramKeyUser.getIsLoadingCommunicationProgramKeyUserFilter(state.CommunicationProgramKeyUser);
//CommunicationKeyUserDispatchFilters
export const getCommunicationKeyUserDispatchFilter = state =>
    fromCommunicationProgramKeyUser.getCommunicationKeyUserDispatchFilter(state.CommunicationProgramKeyUser)

export const getIsLoadingCommunicationKeyUserDispatchFilter = state =>
    fromCommunicationProgramKeyUser.getIsLoadingCommunicationKeyUserDispatchFilter(state.CommunicationProgramKeyUser);
//CommunicationProgramKeyUserSummary
export const getCommunicationsProgramKeyUserSummary = state =>
    fromCommunicationProgramKeyUser.getCommunicationsProgramKeyUserSummary(state.CommunicationProgramKeyUser)
export const getIsLoadingCommunicationsProgramKeyUserSummary = state =>
    fromCommunicationProgramKeyUser.getIsLoadingCommunicationsProgramKeyUserSummary(state.CommunicationProgramKeyUser);
//CommunicationProgramKeyUserSummaryFilters
export const getCommunicationsProgramKeyUserSummaryFilters = state =>
    fromCommunicationProgramKeyUser.getCommunicationsProgramKeyUserSummaryFilters(state.CommunicationProgramKeyUser)
export const getIsLoadingCommunicationsProgramKeyUserSummaryFilters = state =>
    fromCommunicationProgramKeyUser.getIsLoadingCommunicationsProgramKeyUserSummaryFilters(state.CommunicationProgramKeyUser);
//CommunicationProgramKeyUserGraphics
export const getCommunicationKeyUserGraphics = state =>
    fromCommunicationProgramKeyUser.getCommunicationKeyUserGraphics(state.CommunicationProgramKeyUser);
export const communicationKeyUserGraphicsIsLoading = state =>
    fromCommunicationProgramKeyUser.communicationKeyUserGraphicsIsLoading(state.CommunicationProgramKeyUser);
//CommunicationProgramKeyUserDetails
export const getCommunicationsProgramKeyUserDetails = state =>
    fromCommunicationProgramKeyUser.getCommunicationsProgramKeyUserDetails(state.CommunicationProgramKeyUser)
export const getIsLoadingCommunicationsProgramKeyUserDetails = state =>
    fromCommunicationProgramKeyUser.getIsLoadingCommunicationsProgramKeyUserDetails(state.CommunicationProgramKeyUser);

//Communication
export const getPendingCommunication = state =>
    fromEmployeeCommunicationProgram.getPendingCommunication(state.Communication);
export const getIsLoadingPendingCommunication = state =>
    fromEmployeeCommunicationProgram.getIsLoadingPendingCommunication(state.Communication);
//FinishedCommunication
export const getFinishedCommunication = state =>
    fromEmployeeCommunicationProgram.getFinishedCommunication(state.Communication);
export const getIsLoadingFinishedCommunication = state =>
    fromEmployeeCommunicationProgram.getIsLoadingFinishedCommunication(state.Communication);
//CommunicationProgramByEmployeeId
export const getCommunicationProgramByEmployeeId = state =>
    fromEmployeeCommunicationProgram.getCommunicationProgramByEmployeeId(state.Communication);
export const getIsLoadingCommunicationProgramByEmployeeId = state =>
    fromEmployeeCommunicationProgram.getIsLoadingCommunicationProgramByEmployeeId(state.Communication);
//CommunicationProgramSummary
export const getCommunicationProgramSummary = state =>
    fromEmployeeCommunicationProgram.getCommunicationProgramSummary(state.Communication);
export const getIsLoadingCommunicationProgramSummary = state =>
    fromEmployeeCommunicationProgram.getIsLoadingCommunicationProgramSummary(state.Communication);
//CommunicationProgramSummary
export const getSpecialitySummary = state =>
    fromEmployeeCommunicationProgram.getSpecialitySummary(state.Communication);
export const getIsLoadingSpecialitySummary = state =>
    fromEmployeeCommunicationProgram.getIsLoadingSpecialitySummary(state.Communication);
//CommunicationProgramSummary
export const getSystemSummary = state =>
    fromEmployeeCommunicationProgram.getSystemSummary(state.Communication);
export const getIsLoadingSystemSummary = state =>
    fromEmployeeCommunicationProgram.getIsLoadingSystemSummary(state.Communication);
//CommunicationProgramSummary
export const getComplianceAdvance = state =>
    fromEmployeeCommunicationProgram.getComplianceAdvance(state.Communication);
export const getIsLoadingComplianceAdvance = state =>
    fromEmployeeCommunicationProgram.getIsLoadingComplianceAdvance(state.Communication);

//EndCommunication
export const getEndCommunication = state =>
    fromEmployeeCommunicationProgram.getEndCommunication(state.Communication);
export const getIsLoadingEndCommunication = state =>
    fromEmployeeCommunicationProgram.getIsLoadingEndCommunication(state.Communication);

export const getIsLoadingQualificationProcess = state =>
    fromEmployeeCommunicationProgram.getIsLoadingQualificationProcess(state.Communication);

//CommunicationQuiz
export const getCommunicationQuiz = state =>
    fromEmployeeCommunicationQuiz.getCommunicationQuiz(state.CommunicationQuiz);
export const getIsLoadingCommunicationQuiz = state =>
    fromEmployeeCommunicationQuiz.getIsLoadingCommunicationQuiz(state.CommunicationQuiz);
//ResponsableQuiz
export const getResponsableQuiz = state =>
    fromEmployeeCommunicationQuiz.getResponsableQuiz(state.CommunicationQuiz)
export const getIsLoadingResponsableQuiz = state =>
    fromEmployeeCommunicationQuiz.getIsLoadingResponsableQuiz(state.CommunicationQuiz);

//Course
export const getCourse = state =>
    fromCourse.getCourse(state.Course);
export const getIsLoadingCourse = state =>
    fromCourse.getIsLoadingCourse(state.Course);
export const getCourseFilter = state =>
    fromCourse.getCourseFilter(state.Course);
//CoursesAvailable
export const getCourseAvailable = state =>
    fromCourseAvailable.getCourseAvailable(state.CourseAvailable);

//CategoryAvailable
export const getCategoryAvailable = state =>
    fromCategoryAvailable.getCategoryAvailable(state.CategoryAvailable);
//Category
export const getCategory = state =>
    fromCategory.getCategory(state.Category);
//CategoryCourse
export const getCategoryCourse = state =>
    fromCategoryCourse.getCategoryCourse(state.CategoryCourse);
//CategoryCourseAvailable
export const getCategoryCourseAvailable = state =>
    fromCategoryCourseAvailable.getCategoryCourseAvailable(state.CategoryCourseAvailable);

//CommunicationPrograms - Diffusion
export const getCommunicationProgramDiffusion = state =>
    fromCommunicationProgram.getCommunicationProgramDiffusion(state.CommunicationProgram);
export const getIsLoadingCommunicationProgramDiffusion = state =>
    fromCommunicationProgram.getIsLoadingCommunicationProgramDiffusion(state.CommunicationProgram);
//CommunicationPrograms - Course
export const getCommunicationProgramCourse = state =>
    fromCommunicationProgram.getCommunicationProgramCourse(state.CommunicationProgram);
export const getIsLoadingCommunicationProgramCourse = state =>
    fromCommunicationProgram.getIsLoadingCommunicationProgramCourse(state.CommunicationProgram);
//CommunicationPrograms - CourseAvailable
export const getCommunicationProgramCourseAvailable = state =>
    fromCommunicationProgram.getCommunicationProgramCourseAvailable(state.CommunicationProgram);
export const getIsLoadingCommunicationProgramCourseAvailable = state =>
    fromCommunicationProgram.getIsLoadingCommunicationProgramCourseAvailable(state.CommunicationProgram);

//Company
export const getCompany = state =>
    fromCompany.getCompany(state.Company);

export const getIsLoadingCompany = state =>
    fromCompany.getIsLoadingCompany(state.Company);

export const getCompanyFilter = state =>
    fromCompany.getCompanyFilter(state.Company);

//ClientProcedure
export const getClientProcedure = state =>
    fromClientProcedure.getClientProcedure(state.ClientProcedure);

export const getIsLoadingClientProcedure = state =>
    fromClientProcedure.getIsLoadingClientProcedure(state.ClientProcedure);

export const getClientProcedureFilter = state =>
    fromClientProcedure.getClientProcedureFilter(state.ClientProcedure);

//HomologousProcedure
export const getHomologousProcedure = state =>
    fromHomologousProcedure.getHomologousProcedure(state.HomologousProcedure);

export const getIsLoadingHomologousProcedure = state =>
    fromHomologousProcedure.getIsLoadingHomologousProcedure(state.HomologousProcedure);

export const getHomologousProcedureFilter = state =>
    fromHomologousProcedure.getHomologousProcedureFilter(state.HomologousProcedure);

//TechnicalRepresentative
export const getTechnicalRepresentative = state =>
    fromTechnicalRepresentative.getTechnicalRepresentative(state.TechnicalRepresentative);

export const getIsLoadingTechnicalRepresentative = state =>
    fromTechnicalRepresentative.getIsLoadingTechnicalRepresentative(state.TechnicalRepresentative);

export const getTechnicalRepresentativeFilter = state =>
    fromTechnicalRepresentative.getTechnicalRepresentativeFilter(state.TechnicalRepresentative);


//AdministrativeRepresentative
export const getAdministrativeRepresentative = state =>
    fromAdministrativeRepresentative.getAdministrativeRepresentative(state.AdministrativeRepresentative);

export const getIsLoadingAdministrativeRepresentative = state =>
    fromAdministrativeRepresentative.getIsLoadingAdministrativeRepresentative(state.AdministrativeRepresentative);

export const getAdministrativeRepresentativeFilter = state =>
    fromAdministrativeRepresentative.getAdministrativeRepresentativeFilter(state.AdministrativeRepresentative);

//SSPARepresentative
export const getSSPARepresentative = state =>
    fromSSPARepresentative.getSSPARepresentative(state.SSPARepresentative);

export const getIsLoadingSSPARepresentative = state =>
    fromSSPARepresentative.getIsLoadingSSPARepresentative(state.SSPARepresentative);

export const getSSPARepresentativeFilter = state =>
    fromSSPARepresentative.getSSPARepresentativeFilter(state.SSPARepresentative);

//PEPRepresentative
export const getPEPRepresentative = state =>
    fromPEPRepresentative.getPEPRepresentative(state.PEPRepresentative);

export const getIsLoadingPEPRepresentative = state =>
    fromPEPRepresentative.getIsLoadingPEPRepresentative(state.PEPRepresentative);

export const getPEPRepresentativeFilter = state =>
    fromPEPRepresentative.getPEPRepresentativeFilter(state.PEPRepresentative);

//ACCPSupervisor
export const getACCPSupervisor = state =>
    fromACCPSupervisor.getACCPSupervisor(state.ACCPSupervisor);

export const getIsLoadingACCPSupervisor = state =>
    fromACCPSupervisor.getIsLoadingACCPSupervisor(state.ACCPSupervisor);

export const getACCPSupervisorFilter = state =>
    fromACCPSupervisor.getACCPSupervisorFilter(state.ACCPSupervisor);

export const getACCPSupervisorAvailable = state =>
    fromACCPSupervisor.getACCPSupervisorAvailable(state.ACCPSupervisor);

export const getIsLoadingACCPSupervisorAvailable = state =>
    fromACCPSupervisor.getIsLoadingACCPSupervisorAvailable(state.ACCPSupervisor);

//ACCPBoss
export const getACCPBoss = state =>
    fromACCPBoss.getACCPBoss(state.ACCPBoss);

export const getIsLoadingACCPBoss = state =>
    fromACCPBoss.getIsLoadingACCPBoss(state.ACCPBoss);

export const getACCPBossFilter = state =>
    fromACCPBoss.getACCPBossFilter(state.ACCPBoss);

export const getACCPBossAvailable = state =>
    fromACCPBoss.getACCPBossAvailable(state.ACCPBoss);

export const getIsLoadingACCPBossAvailable = state =>
    fromACCPBoss.getIsLoadingACCPBossAvailable(state.ACCPBoss);

//PROCESS
export const getProcess = state =>
    fromProcess.getProcess(state.Process);

export const getIsLoadingProcess = state =>
    fromProcess.getIsLoadingProcess(state.Process);
//PROCESS FILTERS
export const getProcessFilters = state =>
    fromProcess.getProcessFilters(state.Process);

export const getIsLoadingProcessFilters = state =>
    fromProcess.getIsLoadingProcessFilters(state.Process);

//MANAGEMENT REPORT FILTERS
export const getManagementReportFilters = state =>
    fromManagementReport.getManagementReportFilters(state.ManagementReport);

export const getIsLoadingManagementReportFilters = state =>
    fromManagementReport.getIsLoadingManagementReportFilters(state.ManagementReport);

//MANAGEMENT REPORT
export const getManagementReport = state =>
    fromManagementReport.getManagementReport(state.ManagementReport);

export const getIsLoadingManagementReport = state =>
    fromManagementReport.getIsLoadingManagementReport(state.ManagementReport);

//DISCLAIMER

export const disclaimerActiveIsLoading = state =>
    fromDisclaimer.getIsLoadingDisclaimerActive(state.Disclaimer);
export const disclaimerActive = state =>
    fromDisclaimer.getDisclaimerActive(state.Disclaimer);

//OnSiteEvaluation
export const getOnSiteEvaluationsFilters = state =>
    fromOnSiteEvaluations.getOnSiteEvaluationsFilters(state.OnSiteEvaluations);
export const getIsLoadingOnSiteEvaluationsilters = state =>
    fromOnSiteEvaluations.getIsLoadingOnSiteEvaluationsilters(state.OnSiteEvaluations);
export const getOnSiteEvaluations = state =>
    fromOnSiteEvaluations.getOnSiteEvaluations(state.OnSiteEvaluations);
export const getOnSiteEvaluationsCalFilters = state =>
    fromOnSiteEvaluations.getOnSiteEvaluationsCalFilters(state.OnSiteEvaluations);
export const getOnSiteEvaluationsCal = state =>
    fromOnSiteEvaluations.getOnSiteEvaluationsCal(state.OnSiteEvaluations);

